<template lang="html">
    <div class="container" id="text-page">
      
      <h1 class="mb-3 page-title">Politica de Devoluciones y Reembolsos</h1>
      
      <div class="content" v-html="row"></div>

      <!-- <div class="content">
        <p>
          Bazaar Flex, operado por Bazaar Flex S.A. DE C.V., con domicilio en Sienita 2074, Colonia Mariano Otero, Zapopan, Jalisco, México, C.P. 45067, establece la siguiente política:
        </p>

        <br />
        <h5>1. PLAZO PARA DEVOLUCIONES</h5>
        <p>
          Las devoluciones deben solicitarse dentro de los 15 días naturales posteriores a la entrega del producto.
        </p>

        <br />
        <h5>2. CONDICIONES PARA ACEPTAR UNA DEVOLUCIÓN</h5>
        <p>
          El producto debe encontrarse en perfectas condiciones, sin haber sido usado y en su empaque original, con todos los accesorios, manuales y etiquetas. Se requiere evidencia fotográfica enviada a contacto@bazaarflex.com.com.mx.
        </p>

        <br />
        <h5>3. EXCLUSIONES</h5>
        <p>
          No se aceptan devoluciones de:
        </p>
        <ul>
          <li>Alimentos perecederos.</li>
          <li>Cosméticos, suplementos o productos de higiene abiertos.</li>
          <li>Productos hechos a medida o personalizados.</li>
        </ul>

        <br />
        <h5>4. PROCEDIMIENTO</h5>
        <p>
          El cliente debe contactar a Bazaar Flex vía correo electrónico. Nuestro equipo validará la solicitud en un plazo de 72 horas. Si procede, se proporcionará una guía de retorno. Una vez recibido el producto y verificado su estado, se procesará el reembolso.
        </p>

        <br />
        <h5>5. REEMBOLSOS</h5>
        <p>
          Los reembolsos se realizan al método de pago original en un plazo de 7 a 15 días hábiles. El costo de envío original no es reembolsable, salvo en casos de error del proveedor.
        </p>

        <br />
        <h5>6. GARANTÍAS</h5>
        <p>
          Cualquier garantía del producto corresponde exclusivamente al productor.
        </p>

        <br />
        <h5>7. JURISDICCIÓN</h5>
        <p>
          Cualquier controversia se resolverá conforme a la legislación mexicana, ante tribunales de Zapopan, Jalisco.
        </p>
      </div> -->

    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/politica')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
